module.exports = __webpack_public_path__ + "static/media/bottom.6d4584cf.png";